export const SITE_TYPE = "NAVER_SMARTSTORE";
